import { createTheme } from "@mui/material/styles";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#C4161C",
      light: "#FCE8E9",
      dark: "#9E1217",
    },
    secondary: {
      main: "#F4B400",
      light: "#FFF4D6",
      dark: "#C99700",
    },
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    success: {
      main: "#16A34A",
      light: "#DCFCE7",
    },
    warning: {
      main: "#F59E0B",
      light: "#FEF3C7",
    },
    error: {
      main: "#DC2626",
      light: "#FEE2E2",
    },
    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    h1: { fontSize: "24px", fontWeight: 600 },
    h2: { fontSize: "20px", fontWeight: 600 },
    h3: { fontSize: "18px", fontWeight: 500 },
    body1: { fontSize: "14px" },
    body2: { fontSize: "13px" },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
          padding: "8px 16px",
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
    },
  },
});

export default muiTheme;
